export interface VisualConceptResponse {
  visual_concept: string;
  image_generation_prompt: string;
}

export interface GenerationResult {
  concept: string;
  prompt: string;
  imageUrl: string;
  watermarkText: string;
}

export interface Sketch {
  id: string;
  image_url: string;
  concept: string;
  prompt: string;
  created_at: string;
}

export interface UserProfile {
  id: string;
  email: string;
  credits: number;
  has_purchased: boolean;
}

export enum LoadingState {
  IDLE = 'IDLE',
  CONCEPTUALIZING = 'CONCEPTUALIZING',
  GENERATING_IMAGE = 'GENERATING_IMAGE',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
}